import { onPath } from '../utils/path';
import { getWindow, whenOlarkExists } from '../utils/dom-utils';
import problemSiteIds from '../utils/problem-site-ids';
// import Glide from '@glidejs/glide';
import AOS from 'aos';

onPath(['/', '/welcome'], () => {
  whenOlarkExists(olark => {

    const loc = getWindow().document.location.toString();
    const has_rid = loc.match(/rid=\d+\-\d+\-\d+/);

    if (!has_rid) {
      return olark("api.box.show");
    }

    olark("api.box.hide");

    const matched_ids = problemSiteIds.filter(id => loc.match("rid=#{id}"));

    if (!matched_ids.length) {
      setTimeout(() => {
        olark("api.box.show")
      }, 30000);
    }

  });

  // Image carousel library
  // var glide = new Glide('.glide', {
    // autoplay: 5000,
  //   type: 'carousel',
  //   animationDuration: 1000
  // })  

  // glide.mount();

  // Animate on scroll library
  AOS.init({
    disable: 'mobile',
    once: true
  });

});